<template>
  <div class="bc-white padding-20 br-4">
    <div class="display-flex ai-center jc-space-between">
      <div>
        <b class="fs-18">人员管理</b>
        <p class="page-desc">管理系统使用人员，控制账号状态与到期提醒接收。</p>
      </div>
      <el-button type="primary" icon="el-icon-plus" @click="addPersonnel">新增人员</el-button>
    </div>

    <!-- 搜索 -->
    <div class="display-flex ai-center mt-20">
      <el-input
        v-model="searchForm.fuzzy"
        clearable
        placeholder="请输入姓名或手机号"
        style="width: 260px"
        @input="handleFuzzyInput"
        @clear="handleSearch"
        @keyup.enter.native="handleSearch">
      </el-input>
      <el-button class="ml-10" type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
      <el-button class="ml-10" icon="el-icon-refresh-left" @click="handleReset">重置</el-button>
    </div>

    <!-- 人员表格 -->
    <el-table class="mt-20" :data="tableData" v-loading="tableLoading" border>
      <el-table-column prop="name" label="姓名" min-width="120"></el-table-column>
      <el-table-column prop="mobile" label="手机号" min-width="140">
        <template slot-scope="{ row }">
          <div class="mobile-cell">
            <span>{{ row.mobile || '-' }}</span>
            <a v-if="row.mobile" :href="'tel:' + row.mobile" class="color-primary" :aria-label="'拨打电话 ' + row.mobile" :title="'拨打电话 ' + row.mobile">
              <i class="el-icon-phone-outline"></i>
            </a>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="角色" width="110" align="center">
        <template slot-scope="{ row }">
          <el-tag size="small" :type="roleTagType(row.roleType)" effect="plain">{{ roleText(row.roleType) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="是否接收提醒" width="120" align="center">
        <template slot-scope="{ row }">
          <el-tag size="small" :type="notifyTagType(row.notifyFlag)" effect="plain">{{ notifyText(row.notifyFlag) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="110" align="center">
        <template slot-scope="{ row }">
          <span
            class="state-switch"
            :class="{ 'is-on': row.state === 1 }"
            @click="handleStateChange(row, row.state !== 1)">
            <i class="state-switch__dot"></i>
            <span class="state-switch__text">{{ row.state === 1 ? '启用' : '禁用' }}</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="备注" min-width="160" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <span :class="{ 'color-info': !row.remark }">{{ row.remark || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="110" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="editPersonnel(row)">编辑</el-button>
          <el-button type="text" class="color-danger" @click="delPersonnel(row)">删除</el-button>
        </template>
      </el-table-column>
      <template slot="empty">
        <el-empty description="暂无人员" :image-size="80"></el-empty>
      </template>
    </el-table>

    <div class="display-flex jc-flex-end mt-16">
      <el-pagination
        background
        @current-change="handlePageChange"
        :current-page="searchForm.pageNum"
        :page-size="searchForm.pageSize"
        layout="total, prev, pager, next"
        :total="total">
      </el-pagination>
    </div>

    <!-- 新增/编辑人员 -->
    <el-dialog
      :title="personnelDialog.id ? '编辑人员' : '新增人员'"
      :visible.sync="personnelDialog.show"
      width="560px"
      append-to-body>
      <el-form :model="personnelDialog.form" label-position="top" class="diy-top-form" v-loading="personnelDialog.loading">
        <el-form-item label="姓名" required>
          <el-input v-model="personnelDialog.form.name" maxlength="50" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号" required>
          <el-input v-model="personnelDialog.form.mobile" maxlength="11" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <span
            class="state-switch"
            :class="{ 'is-on': personnelDialog.form.enabled }"
            @click="personnelDialog.form.enabled = !personnelDialog.form.enabled">
            <i class="state-switch__dot"></i>
            <span class="state-switch__text">{{ personnelDialog.form.enabled ? '启用' : '禁用' }}</span>
          </span>
        </el-form-item>
        <el-form-item label="角色">
          <el-radio-group v-model="personnelDialog.form.roleType" class="compact-radio">
            <el-radio :label="1">管理人员（可登录系统）</el-radio>
            <el-radio :label="2">销售人员（不可进入系统）</el-radio>
            <el-radio :label="3">其他（不可进入系统）</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否接收提醒">
          <el-radio-group v-model="personnelDialog.form.notifyFlag" class="compact-radio">
            <el-radio :label="1">接收全部推送</el-radio>
            <el-radio :label="2">接收部分推送（可在客户信息编辑处选中推送）</el-radio>
            <el-radio :label="0">不接收推送</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="personnelDialog.form.remark"
            type="textarea"
            :rows="3"
            maxlength="100"
            show-word-limit
            placeholder="请输入备注">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="personnelDialog.show = false">取 消</el-button>
        <el-button type="primary" :loading="personnelDialog.loading" @click="submitPersonnel">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'PersonnelList', // 人员管理
  components: {},
  props: {},
  data () {
    return {
      searchForm: {
        fuzzy: '',
        pageNum: 1,
        pageSize: 10
      },
      tableLoading: false,
      tableData: [],
      total: 0,
      searchTimer: null,
      // 新增/编辑人员弹框
      personnelDialog: {
        show: false,
        loading: false,
        id: null,
        form: {
          name: '',
          mobile: '',
          enabled: true,
          roleType: 1,
          notifyFlag: 0,
          remark: ''
        }
      }
    }
  },
  filters: {},
  computed: {},
  watch: {},
  methods: {
    /**
     * 角色文案：1管理人员 2销售人员 3其他
     */
    roleText (roleType) {
      return { 1: '管理人员', 2: '销售人员', 3: '其他' }[roleType] || '-'
    },
    /**
     * 角色标签颜色
     */
    roleTagType (roleType) {
      return { 1: 'primary', 2: 'success', 3: 'info' }[roleType] || 'info'
    },
    /**
     * 接收提醒文案：1接收全部推送 2接收部分推送 0不接收推送
     */
    notifyText (notifyFlag) {
      return { 1: '接收全部推送', 2: '接收部分推送', 0: '不接收推送' }[notifyFlag] || '不接收推送'
    },
    /**
     * 接收提醒标签颜色
     */
    notifyTagType (notifyFlag) {
      return { 1: 'success', 2: 'warning', 0: 'info' }[notifyFlag] || 'info'
    },
    /**
     * 人员分页列表
     */
    getTableData () {
      this.tableLoading = true
      const data = {
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize
      }
      if (this.searchForm.fuzzy.trim()) data.fuzzy = this.searchForm.fuzzy.trim()
      this.$api.organization.personnelList(data).then(res => {
        this.tableLoading = false
        this.tableData = res.list || []
        this.total = res.total || 0
      }).catch(() => {
        this.tableLoading = false
      })
    },
    /**
     * 输入即查询（防抖 400ms，直接调查询接口）
     */
    handleFuzzyInput () {
      clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => {
        this.handleSearch()
      }, 400)
    },
    /**
     * 查询
     */
    handleSearch () {
      this.searchForm.pageNum = 1
      this.getTableData()
    },
    /**
     * 重置
     */
    handleReset () {
      this.searchForm.fuzzy = ''
      this.searchForm.pageNum = 1
      this.getTableData()
    },
    /**
     * 翻页
     */
    handlePageChange (page) {
      this.searchForm.pageNum = page
      this.getTableData()
    },
    /**
     * 新增人员
     */
    addPersonnel () {
      this.personnelDialog.id = null
      this.personnelDialog.form = {
        name: '',
        mobile: '',
        enabled: true,
        roleType: 1,
        notifyFlag: 0,
        remark: ''
      }
      this.personnelDialog.show = true
    },
    /**
     * 编辑人员（先查详情回显）
     */
    editPersonnel (row) {
      this.personnelDialog.id = row.id
      this.personnelDialog.loading = true
      this.personnelDialog.show = true
      this.$api.organization.personnelDetail({ id: row.id }).then(res => {
        this.personnelDialog.loading = false
        this.personnelDialog.form = {
          name: res.name || '',
          mobile: res.mobile || '',
          enabled: res.state === 1,
          roleType: [1, 2, 3].includes(res.roleType) ? res.roleType : 1,
          notifyFlag: [0, 1, 2].includes(res.notifyFlag) ? res.notifyFlag : 0,
          remark: res.remark || ''
        }
      }).catch(() => {
        this.personnelDialog.loading = false
      })
    },
    /**
     * 保存人员
     */
    submitPersonnel () {
      const form = this.personnelDialog.form
      if (!form.name.trim()) {
        this.$message.warning('请输入姓名')
        return
      }
      if (!/^1\d{10}$/.test(form.mobile.trim())) {
        this.$message.warning('请输入正确的手机号')
        return
      }
      const data = {
        name: form.name.trim(),
        mobile: form.mobile.trim(),
        state: form.enabled ? 1 : 2,
        roleType: form.roleType,
        notifyFlag: form.notifyFlag,
        remark: form.remark.trim()
      }
      this.personnelDialog.loading = true
      // 编辑传 id，新增不传
      const request = this.personnelDialog.id
        ? this.$api.organization.updatePersonnel({ ...data, id: this.personnelDialog.id })
        : this.$api.organization.addPersonnel(data)
      request.then(res => {
        this.personnelDialog.loading = false
        this.$message.success('保存成功')
        this.personnelDialog.show = false
        this.getTableData()
      }).catch(() => {
        this.personnelDialog.loading = false
      })
    },
    /**
     * 启用/禁用状态切换（update 接口 name、mobile 必填，一并带上）
     */
    handleStateChange (row, val) {
      const state = val ? 1 : 2
      const data = { id: row.id, name: row.name, mobile: row.mobile, state }
      this.$api.organization.updatePersonnel(data).then(res => {
        this.$message.success(val ? '已启用' : '已禁用')
        row.state = state
      }).catch(() => {
      })
    },
    /**
     * 删除人员
     */
    delPersonnel (row) {
      this.$confirm(`确定删除人员“${row.name}”吗？`, '删除人员', {
        confirmButtonText: '确认删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.organization.deletePersonnel([row.id]).then(res => {
          this.$message.success('删除成功')
          // 删除后当前页可能空了，回退一页
          if (this.tableData.length === 1 && this.searchForm.pageNum > 1) {
            this.searchForm.pageNum -= 1
          }
          this.getTableData()
        }).catch(() => {
        })
      }).catch(() => {
      })
    }
  },
  beforeCreate () {
  },
  created () {
  },
  beforeMount () {
  },
  mounted () {
    this.getTableData()
  },
  beforeUpdate () {
  },
  updated () {
  },
  beforeDestroy () {
    clearTimeout(this.searchTimer)
  },
  destroyed () {
  }
}
</script>

<style lang="scss" scoped>
.mobile-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.page-desc {
  margin: 6px 0 0;
  font-size: 13px;
  color: #909399;
}
// 弹框内单选组：压缩间距，保证三个选项一行放下
.compact-radio {
  ::v-deep .el-radio {
    margin-right: 14px;

    &:last-child {
      margin-right: 0;
    }
  }
  ::v-deep .el-radio__label {
    padding-left: 6px;
    font-size: 13px;
  }
}
// 状态胶囊开关：启用=绿色实心圆点在右，禁用=红色浅色圆点在左
.state-switch {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 10px;
  border-radius: 11px;
  font-size: 12px;
  cursor: pointer;
  user-select: none;
  background: #FEF0F0;
  color: #F56C6C;
  transition: background .2s;

  &__dot {
    width: 10px;
    height: 10px;
    margin-right: 6px;
    border-radius: 50%;
    background: #fff;
    border: 2px solid #F56C6C;
    box-sizing: border-box;
  }

  &.is-on {
    flex-direction: row-reverse;
    background: #67C23A;
    color: #fff;

    .state-switch__dot {
      margin-right: 0;
      margin-left: 6px;
      border-color: #fff;
    }
  }
}
.color-danger {
  color: #F56C6C;
}
</style>
